import React from 'react';
import {t} from 'ttag';
import {Box, Card, CardContent, CardHeader, Grid2, Typography} from '@mui/material';
import {IInvoice} from '../../../store/apis/interfaces/invoice';
import {LabeledField, styles} from 'scenes/invoice-system';

interface TicketHeaderProps {
  ticketId?: string;
  data: IInvoice;
}

export const TicketHeader = ({ticketId, data}: TicketHeaderProps) => {
  const getPassengerName = (name: string) => {
    if (!name) return 'N/A';
    const safeName = name?.toLowerCase() || '';
    let [lastName, firstName] = safeName ? safeName.split(/[/\\]/) : [];
    firstName = firstName?.replace(/(mr|mrs)$/i, '').trim();
    return `${firstName?.[0]?.toUpperCase() + firstName?.slice(1)}
    ${lastName
      ?.split(' ')
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(' ')}`;
  };

  const getFlightDate = (date: string) => `${date?.slice(0, 4)}-${date?.slice(4, 6)}-${date?.slice(6, 8)}`;

  return (
    <Card variant={'outlined'}>
      <CardHeader
        sx={{backgroundColor: 'rgba(88, 176, 237, 0.25)'}}
        title={
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            flexDirection={{xs: 'column', md: 'row'}}
            alignItems={{xs: 'start', md: 'center'}}
          >
            <Typography sx={styles.title}>{t`Ticket` + ` ${ticketId}`}</Typography>
            <Typography variant={'body2'}>{t`Issue date` + `: ${data?.docDate || 'N/A'}`}</Typography>
          </Box>
        }
      />
      <CardContent>
        <Grid2 container justifyContent={'space-between'} spacing={2}>
          <Grid2 size={{xs: 12, md: 6}}>
            <LabeledField label={t`Passenger`} value={getPassengerName(data?.details?.Paxname)} />
          </Grid2>
          <Grid2 size={{xs: 12, md: 6}}>
            <LabeledField
              label={t`Amount`}
              value={`${data?.details?.Payment?.reduce((sum, item) => sum + (Number(item?.Amount) || 0), 0)?.toFixed(
                2
              )} ${data?.details?.Currency}`}
            />
          </Grid2>
          <Grid2 size={{xs: 12, md: 6}}>
            <LabeledField label={t`Routes`}>
              <Box display={'flex'} flexDirection={'column'}>
                {data?.details?.Coupons?.map((coupon, index) => (
                  <Typography
                    key={`${(coupon.From || '') + (coupon.To || '')}${index}`}
                    variant={'body1'}
                    fontFamily={'OpenSansMedium'}
                  >{`${coupon.From || 'N/A'} - ${coupon.To || 'N/A'}`}</Typography>
                )) || (
                  <Typography variant={'body1'} fontFamily={'OpenSansMedium'}>
                    {'N/A'}
                  </Typography>
                )}
              </Box>
            </LabeledField>
          </Grid2>
          <Grid2 size={{xs: 12, md: 6}}>
            <LabeledField label={t`Flights`}>
              <Box display={'flex'} flexDirection={'column'}>
                {data?.details?.Coupons?.map((coupon, index) => (
                  <Typography key={coupon.Carrier ?? '' + index} variant={'body1'} fontFamily={'OpenSansMedium'}>{`${coupon.Date ? getFlightDate(
                    coupon.Date
                  ) : ''} ${coupon.Carrier || 'N/A'}${coupon.Flight || ''}`}</Typography>
                )) || (
                  <Typography variant={'body1'} fontFamily={'OpenSansMedium'}>
                    {'N/A'}
                  </Typography>
                )}
              </Box>
            </LabeledField>
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  );
};
